/**
 * Old page addresses that were merged into tabbed hub pages. They stay routable (bookmarks, docs,
 * e-mails) and redirect to the hub tab that now holds the content.
 */
export type LegacyRedirect = { from: string; to: string };

export const LEGACY_REDIRECTS: LegacyRedirect[] = [
  { from: "/audit-log", to: "/logs?tab=audit" },
  { from: "/business-errors", to: "/logs?tab=errors" },
  { from: "/mail-settings", to: "/super-admin/mail" },
  { from: "/ai-guide", to: "/ai-context?tab=documents" },
  { from: "/data-structure-analytics", to: "/schema-relations" },
  { from: "/chat-query-examples", to: "/ai-context?tab=examples" },
  { from: "/ingest", to: "/data-sources?tab=ingest" },
  { from: "/admin/data-adaptors", to: "/data-sources?tab=adaptors" },
  { from: "/admin/ingest", to: "/data-sources?tab=governance" },
  { from: "/admin/prep-jobs", to: "/data-prep?tab=approvals" },
  { from: "/dashboard-queries", to: "/widgets?tab=queries" },
  { from: "/anomalies/incidents", to: "/anomalies?tab=incidents" },
  { from: "/anomalies/runs", to: "/anomalies?tab=runs" },
];

/** Where an old path should go, or null when the path was not merged. */
export function resolveLegacyRedirect(pathname: string): string | null {
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  return LEGACY_REDIRECTS.find((r) => r.from === normalized)?.to ?? null;
}
